// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_Village_SpeciesGender_Board_container__1yuCx"};